import React, { FC } from 'react';

interface OwnProps {
  id?: string;
  key?: string;
  onClick?: () => void | null;
}

export const ExperimentIcon: FC<OwnProps> = ({ id, key, onClick }) => {
  return (
    <svg
      id={id}
      key={key}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      onClick={onClick}
      cursor={onClick ? 'pointer' : 'default'}
    >
      <g clipPath="url(#clip0_2596_36881)">
        <path
          d="M10.2534 1H5.81982C5.34314 1 4.93273 1.33646 4.83924 1.80388L3.73924 7.30388C3.61548 7.92268 4.08878 8.5 4.71982 8.5H6.50002L5.6068 14.3059C5.55066 14.6709 5.83303 15 6.20229 15C6.38994 15 6.56688 14.9126 6.68088 14.7635L12.8464 6.7009C12.946 6.5706 13 6.41112 13 6.24709C13 5.83448 12.6655 5.5 12.2529 5.5H10.5L11.2296 2.21693C11.3684 1.59242 10.8932 1 10.2534 1Z"
          fill="#136FD8"
        />
      </g>
      <defs>
        <clipPath id="clip0_2596_36881">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
